const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Link = require("../core/view/Link");
const URLMake = require("../../shared/URLMake");
const AssetsUtil = require("../core/util/AssetsUtil");
const CopyTable = require("./data/CopyTable");

const styles = require("./styles/PageMailingList.css");

module.exports = createReactClass({
	displayName: "PageEnableAutoRenew",

	propTypes: {
		// enabled - for a valid autorenew code
		// error - for an invalid or expired autorenew code
		type: PT.oneOf(["enabled", "error"]).isRequired,
	},

	render: function() {
		const {type} = this.props;
		const Copy = CopyTable.getEnableAutoRenewCopy();
		const message = Copy[type];
		const imgSrc =
			type === "enabled"
				? global.BASE_URL +
				  "assets/images/office/characters/happy-fiona-grok.svg"
				: AssetsUtil.getGotProblems();

		const button = (
			<Link to={URLMake.forAccount()} className={styles.button}>
				MY ACCOUNT
			</Link>
		);

		return (
			<div className={styles.main}>
				<img className={styles.image} src={imgSrc} />
				<div className={styles.message}>{message}</div>
				{button}
			</div>
		);
	},
});
